import React, { Component } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.bubble.css";

import { V2Header } from "./V2Page";

// The two "Your HR practices in numbers" slides - strengths and KPIs to
// improve.
//
// Both are free text the certifier writes, with a panel of suggested sentences
// beside the slide. Clicking a suggestion appends it as a bullet. Same
// behaviour as V1's ReportCategoryHightlightsSuggestions, but rendered in the
// V2 page shell instead of the category layout, which is built around a donut
// and a title column these slides do not have.
//
// The panel sits outside .report-v2__page so it never appears in the PDF.
const editorModules = {
  syntax: false,
  toolbar: [
    ["bold", "italic", "underline"],
    [{ size: ["small", false, "large", "huge"] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["clean"],
  ],
};

export default class V2EditableHighlights extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentContent: this.props.content ? this.props.content : "",
    };
  }

  // The editor is uncontrolled once typing starts, so it must not re-render on
  // every keystroke of the debounced save - same guard as V1.
  shouldComponentUpdate(nextProps, nextState) {
    return (
      JSON.stringify(this.state) !== JSON.stringify(nextState) ||
      this.props.editable !== nextProps.editable ||
      JSON.stringify(this.props.suggestions) !==
        JSON.stringify(nextProps.suggestions)
    );
  }

  _inputOnChange = (value) => {
    this.props.onChange({
      target: {
        name: this.props.name,
        value: value,
      },
    });

    this.setState({
      currentContent: value,
    });
  };

  // Clicking a suggestion appends it to the list rather than replacing what is
  // already written.
  _suggestionOnClick = (event) => {
    let current = this.state.currentContent;
    const adding = event.currentTarget.innerHTML;

    if (!current || current.indexOf("<ul>") === -1) {
      current = (current ? current : "") + `<ul><li>${adding}</li></ul>`;
    } else {
      current = current.replace("</ul>", `<li>${adding}</li></ul>`);
    }

    this._inputOnChange(current);
  };

  render() {
    const { eyebrow, title, number, id, suggestions, editable, content } =
      this.props;
    const { currentContent } = this.state;

    // The page and the panel are siblings inside .report__page__wrapper, which
    // is the flex row that puts the panel beside the slide - the same structure
    // V1 uses. V2Page closes that wrapper around itself, so the markup is
    // written out here rather than nesting one.
    return (
      <div className="report__page__wrapper" id={id}>
        <div className="report-v2__page report-v2__page--practices">
          <V2Header eyebrow={eyebrow} title={title} />
          <ReactQuill
            readOnly={!editable}
            className="report-v2__editor"
            theme="bubble"
            modules={editorModules}
            value={currentContent}
            defaultValue={content}
            onChange={this._inputOnChange}
          />
          {number !== undefined && (
            <span className="report-v2__page-number">{number}</span>
          )}
        </div>

        {/* Screen only - the slide is what gets printed. */}
        {editable && (suggestions || []).length > 0 && (
          <div className="report__options__row">
            <div className="report__options">
              {suggestions.map((item, key) => (
                <div key={key} className="report__options__checkitem">
                  <p
                    onClick={this._suggestionOnClick}
                    dangerouslySetInnerHTML={{
                      __html: typeof item === "string" ? item : item.content,
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }
}
